/**
 * single entry point for product analytics
 * - app code imports only from here instead of a vendor SDKs directly
 * - a destination is { name, preference, enabled, init, track, identify, reset, page };
 *   adding a tool = one file in ./destinations + one line in ALL_DESTINATIONS
 */

export { EVENTS, SIGNUP_REASONS, SIGNUP_SURFACES } from "./events";
export { buildUserTraits } from "./userTraits";
export {
  initAnalytics,
  setTrackingPreferences,
  track,
  trackSignupCompleted,
  identify,
  reset,
  page
} from "./client";
export {
  peekEntryReason,
  stashGoogleAuthFrom,
  consumeGoogleAuthFrom
} from "./pending";
export { usePageTracking } from "./usePageTracking";
export { useSignupPromptTracking } from "./useSignupPromptTracking";
